// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-third-party-management.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-third-party-management',
  title: 'Allocate AI responsibilities across suppliers and customers',
  description:
    "Confirm that responsibilities are allocated across the AI value chain — including suppliers of AI components, models, data and services, and customers / deployers of the organization's AI systems — and that contracts and agreements document information, support and cooperation obligations sufficient to allow each party to meet its own AI governance duties (ISO/IEC 42001 Annex A.10.2–A.10.4). Review the AI supplier and customer contract templates and sample executed agreements.",
  category: 'vendors',
  scfIds: ['SCF-AIG-012'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'AI supplier-and-customer standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
